class CarouselFull {
  constructor() {
    this.initSlick();
  }

  initSlick() {
    $('.carousel-full__slider').slick({
      centerMode: true,
      centerPadding: '20px',
      slidesToShow: 1,
      dots: true,
      arrows: false,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 8,
            infinite: true,
            dots: true,
            arrows: true,
            centerMode: false
          }
        }
      ]
    });
  }
}

$(document).ready(function() {
  const carouselFull = new CarouselFull();
});